import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const setOffPayment = createAsyncThunk("setOffPayment", async (values, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`order/setoff/payment-status`, values);

		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const RewardPaymentSetOffSlice = createSlice({
	name: "RewardPaymentSetOffSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCreatePriceBookState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(setOffPayment.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(setOffPayment.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(setOffPayment.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default RewardPaymentSetOffSlice.reducer;
